import { $ } from "@/plug/Axios";

export default {
  /**
   * 北开学生
   */
  beijingOpen_batchSync: {
    /*
     * 批量同步考勤和成绩
     * batch 批次 (string query required)
     */
    post: (p, c) => $.post("/api/ems/siteplatform/beijingOpen/batchSync", p, c)
  },
  beijingOpen_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/siteplatform/beijingOpen/export", p, c)
  },
  beijingOpen_list: {
    /*
     * 北开学生列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/beijingOpen/list", p, c)
  },
  beijingOpen_listCourse: {
    /*
     * 课程列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/beijingOpen/listCourse", p, c)
  },
  beijingOpen_sync: {
    /*
     * 同步单个考勤和成绩
     * name 姓名 (string query required)
     * schoolAccount 学校账号 (string query required)
     * schoolPassword 学校密码 (string query required)
     * schoolRollId 学籍id (integer query required)
     */
    post: (p, c) => $.post("/api/ems/siteplatform/beijingOpen/sync", p, c)
  },

  /**
   * 北开学生考勤
   */
  beijingOpenAttendance_list: {
    /*
     * 考勤列表
     * beijingOpenId 北开学生id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/beijingOpenAttendance/list", p, c)
  },

  /**
   * 北开专业
   */
  beijingOpenMajor: {
    /*
     * 添加
     * account 账号 (string query )
     * batch 批次 (string query )
     * id  (integer query )
     * major 专业 (string query )
     * name 姓名 (string query )
     * password 密码 (string query )
     */
    post: (p, c) => $.post("/api/ems/siteplatform/beijingOpenMajor", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/siteplatform/beijingOpenMajor", p, c)
  },
  beijingOpenMajor_createWorkUrl: {
    /*
     * 生成作业
     * batch 批次 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/siteplatform/beijingOpenMajor/createWorkUrl", p, c)
  },
  beijingOpenMajor_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/siteplatform/beijingOpenMajor/export", p, c)
  },
  beijingOpenMajor_getWorkUrl: {
    /*
     * 获取作业下载地址
     * batch 批次 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/beijingOpenMajor/getWorkUrl", p, c)
  },
  beijingOpenMajor_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/beijingOpenMajor/list", p, c)
  },
  beijingOpenMajor_listBatch: {
    /*
     * 批次列表
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/beijingOpenMajor/listBatch", p, c)
  },
  beijingOpenMajor_listMajor: {
    /*
     * 批次列表
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/beijingOpenMajor/listMajor", p, c)
  },
  beijingOpenMajor_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/beijingOpenMajor/upload", p, c)
  },

  /**
   * 北开学生成绩
   */
  beijingOpenScore_list: {
    /*
     * 考勤列表
     * beijingOpenId 北开学生id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/siteplatform/beijingOpenScore/list", p, c)
  },

  /**
   * 工商课程
   */
  gongshangCourse_listCourse: {
    /*
     * 课程列表
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/gongshangCourse/listCourse", p, c)
  },
  gongshangCourse_sync: {
    /*
     * 同步
     */
    post: (p, c) => $.post("/api/ems/siteplatform/gongshangCourse/sync", p, c)
  },

  /**
   * 工商成绩
   */
  gongshangScore: {
    /*
     * 添加
     * batch 批次 (string query )
     * id  (integer query )
     * level 层次 (string query )
     * major 专业 (string query )
     * size 学生数量 (integer query )
     * url 请求地址 (string query )
     */
    post: (p, c) => $.post("/api/ems/siteplatform/gongshangScore", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/siteplatform/gongshangScore", p, c)
  },
  gongshangScore_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/siteplatform/gongshangScore/export", p, c)
  },
  gongshangScore_exportBadScore: {
    /*
     * 导出问题成绩
     * batch 批次 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/gongshangScore/exportBadScore", p, c)
  },
  gongshangScore_getScoreInfo: {
    /*
     * 获取成绩信息
     * url 批次 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/gongshangScore/getScoreInfo", p, c)
  },
  gongshangScore_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/gongshangScore/list", p, c)
  },
  gongshangScore_savePhoto: {
    /*
     * 保存照片
     * idCardNos 身份证 (array query required)
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/gongshangScore/savePhoto", p, c)
  },
  gongshangScore_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/siteplatform/gongshangScore/upload", p, c)
  },

  /**
   * 工商学生成绩
   */
  gongshangStudentScore_continueSync: {
    /*
     * 继续上次同步
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/gongshangStudentScore/continueSync", p, c)
  },
  gongshangStudentScore_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/gongshangStudentScore/export", p, c)
  },
  gongshangStudentScore_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/gongshangStudentScore/list", p, c)
  },
  gongshangStudentScore_reSync: {
    /*
     * 重新同步
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/gongshangStudentScore/reSync", p, c)
  },
  gongshangStudentScore_syncByStudentNo: {
    /*
     * 根据学号同步
     * schoolRollId 合同编号 (integer query required)
     * studentNo 学号 (string query required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/siteplatform/gongshangStudentScore/syncByStudentNo",
        p,
        c
      )
  },

  /**
   * 工商学习情况
   */
  gongshangStudy_batchSync: {
    /*
     * 批量同步
     */
    put: (p, c) => $.put("/api/ems/siteplatform/gongshangStudy/batchSync", p, c)
  },
  gongshangStudy_check: {
    /*
     * 登记
     * id id (integer query required)
     * name 姓名 (string query required)
     * pass 密码 (string query required)
     * studentNo 学号 (string query required)
     * userId 用户id (string query required)
     */
    put: (p, c) => $.put("/api/ems/siteplatform/gongshangStudy/check", p, c)
  },
  gongshangStudy_init: {
    /*
     * 初始化
     */
    post: (p, c) => $.post("/api/ems/siteplatform/gongshangStudy/init", p, c)
  },
  gongshangStudy_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/gongshangStudy/list", p, c)
  },
  gongshangStudy_listTerm: {
    /*
     * 学期列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/gongshangStudy/listTerm", p, c)
  },
  gongshangStudy_sync: {
    /*
     * 同步
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/siteplatform/gongshangStudy/sync", p, c)
  },

  /**
   * 工商学习情况详情
   */
  gongshangStudyDetail: {
    /*
     * 详情
     * schoolRollId 合同id (integer query required)
     * term 学期 (string query required)
     */
    get: (p, c) => $.get("/api/ems/siteplatform/gongshangStudyDetail", p, c)
  },
  gongshangStudyDetail_listTerm: {
    /*
     * 学期列表
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/gongshangStudyDetail/listTerm", p, c)
  },

  /**
   * 杭商院作业记录
   */
  hsyWorkRecord: {
    /*
     * 添加
     * examCookie 考试cookie (string query )
     * id  (integer query )
     * loginCookie 登录cookie (string query )
     * remark  (string query )
     * status 状态（未开始、登录成功、登录失败、作业中，完成） (string query )
     * times 作业次数 (integer query )
     * userName 用户名 (string query )
     */
    post: (p, c) => $.post("/api/ems/siteplatform/hsyWorkRecord", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/siteplatform/hsyWorkRecord", p, c)
  },
  hsyWorkRecord_exportWord: {
    /*
     * 导出word
     * id 课程列表ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/siteplatform/hsyWorkRecord/exportWord", p, c)
  },
  hsyWorkRecord_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/hsyWorkRecord/list", p, c)
  },
  hsyWorkRecord_listCourse: {
    /*
     * 课程列表
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/siteplatform/hsyWorkRecord/listCourse", p, c)
  },
  hsyWorkRecord_listRecord: {
    /*
     * 做题记录列表
     * id 课程列表返回的id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/siteplatform/hsyWorkRecord/listRecord", p, c)
  },
  hsyWorkRecord_removeCourse: {
    /*
     * 删除课程
     * id 课程列表id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/siteplatform/hsyWorkRecord/removeCourse", p, c)
  },
  hsyWorkRecord_removeRecord: {
    /*
     * 删除记录
     * id 记录列表id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/siteplatform/hsyWorkRecord/removeRecord", p, c)
  },
  hsyWorkRecord_start: {
    /*
     * 开始作业
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/ems/siteplatform/hsyWorkRecord/start", p, c)
  },

  /**
   * 计量学生章节情况
   */
  jiliangStudentChapter_batchRestoreChapterTime: {
    /*
     * 单个修复章节时间
     */
    put: (p, c) =>
      $.put(
        "/api/ems/siteplatform/jiliangStudentChapter/batchRestoreChapterTime",
        p,
        c
      )
  },
  jiliangStudentChapter_restoreChapterTime: {
    /*
     * 单个修复章节时间
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put(
        "/api/ems/siteplatform/jiliangStudentChapter/restoreChapterTime",
        p,
        c
      )
  },

  /**
   * 计量学习情况
   */
  jiliangStudy_batchSyncChapterInfo: {
    /*
     * 批量同步章节信息
     */
    put: (p, c) =>
      $.put("/api/ems/siteplatform/jiliangStudy/batchSyncChapterInfo", p, c)
  },
  jiliangStudy_batchUpdateChapterTime: {
    /*
     * 刷课
     */
    put: (p, c) =>
      $.put("/api/ems/siteplatform/jiliangStudy/batchUpdateChapterTime", p, c)
  },
  jiliangStudy_check: {
    /*
     * 登记
     * id id (integer query required)
     * loginInfo 登录信息 (string query required)
     * name 姓名 (string query required)
     * studentNo 学号 (string query required)
     */
    put: (p, c) => $.put("/api/ems/siteplatform/jiliangStudy/check", p, c)
  },
  jiliangStudy_getCurrentTerm: {
    /*
     * 获取当前学期
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/jiliangStudy/getCurrentTerm", p, c)
  },
  jiliangStudy_init: {
    /*
     * 初始化
     */
    post: (p, c) => $.post("/api/ems/siteplatform/jiliangStudy/init", p, c)
  },
  jiliangStudy_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/jiliangStudy/list", p, c)
  },
  jiliangStudy_refresh: {
    /*
     * 刷新
     */
    put: (p, c) => $.put("/api/ems/siteplatform/jiliangStudy/refresh", p, c)
  },
  jiliangStudy_setCurrentTerm: {
    /*
     * 设置当前学期
     * currentTerm 学期 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/jiliangStudy/setCurrentTerm", p, c)
  },
  jiliangStudy_syncChapterInfo: {
    /*
     * 同步章节信息
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/siteplatform/jiliangStudy/syncChapterInfo", p, c)
  },
  jiliangStudy_updateNeedTaskChapter: {
    /*
     * 更新需要刷课的章节（部分课程需要刷完之前的章节，后续章节才会显示）
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/jiliangStudy/updateNeedTaskChapter", p, c)
  },

  /**
   * 经济学生试卷
   */
  jingjiPaper: {
    /*
     * 添加
     * id id (integer query )
     * name 名称 (string query required)
     * rollGrade 学籍年级 (string query required)
     */
    post: (p, c) => $.post("/api/ems/siteplatform/jingjiPaper", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/siteplatform/jingjiPaper", p, c)
  },
  jingjiPaper_exportRecord: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/siteplatform/jingjiPaper/exportRecord", p, c)
  },
  jingjiPaper_finishPaper: {
    /*
     * 生成学生试卷
     * id id, 试卷列表的ID (integer query )
     * reCreate 是否重新生成 (string query required)
     * recordIds 记录列表的ID多选 (array query )
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/jingjiPaper/finishPaper", p, c)
  },
  jingjiPaper_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/jingjiPaper/list", p, c)
  },
  jingjiPaper_listRecord: {
    /*
     * 记录列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/jingjiPaper/listRecord", p, c)
  },
  jingjiPaper_removeRecord: {
    /*
     * 批量删除学生
     * ids ids (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/siteplatform/jingjiPaper/removeRecord", p, c)
  },

  /**
   * 经职院作业
   */
  jingjiWork: {
    /*
     * 添加
     * endTime 结束时间 (string query required)
     * id id (integer query )
     * majorIds 专业（多选） (array query )
     * rollGrade 学籍年级 (string query required)
     * startTime 开始时间 (string query required)
     * theme 主题 (string query required)
     * title 题目 (string query required)
     * type 经济作业类型 (string query required)
     */
    post: (p, c) => $.post("/api/ems/siteplatform/jingjiWork", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/siteplatform/jingjiWork", p, c)
  },
  jingjiWork_checkReference: {
    /*
     * 查看模板效果
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/jingjiWork/checkReference", p, c)
  },
  jingjiWork_exportRecord: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/siteplatform/jingjiWork/exportRecord", p, c)
  },
  jingjiWork_exportSignature: {
    /*
     * 导出学生签名
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/jingjiWork/exportSignature", p, c)
  },
  jingjiWork_finishWork: {
    /*
     * 生成学生作业
     * id id (integer query )
     * reCreate 是否重新生成 (string query required)
     */
    post: (p, c) => $.post("/api/ems/siteplatform/jingjiWork/finishWork", p, c)
  },
  jingjiWork_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/jingjiWork/list", p, c)
  },
  jingjiWork_listRecord: {
    /*
     * 学习记录列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/jingjiWork/listRecord", p, c)
  },
  jingjiWork_listReference: {
    /*
     * 范文列表
     * id id (integer query required)
     * type 类型：试卷或作业或实训报告 (string query required)
     */
    get: (p, c) => $.get("/api/ems/siteplatform/jingjiWork/listReference", p, c)
  },
  jingjiWork_listSignature: {
    /*
     * 学生签名列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/jingjiWork/listSignature", p, c)
  },
  jingjiWork_removeRecord: {
    /*
     * 批量删除学生
     * ids ids (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/siteplatform/jingjiWork/removeRecord", p, c)
  },
  jingjiWork_removeReference: {
    /*
     * 删除范文
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/siteplatform/jingjiWork/removeReference", p, c)
  },
  jingjiWork_saveReference: {
    /*
     * 添加范文
     * content 正文 (string query )
     * id  (integer query )
     * title 标题 (string query )
     * type 类型：作业或试卷或实训报告 (string query )
     * workId 作业ID (integer query )
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/jingjiWork/saveReference", p, c)
  },

  /**
   * 学校平台数据处理
   */
  sitePlatformDataHandler_exportGongshangGradeInput: {
    /*
     * 成绩输入数据导出
     * classId 班级id (integer query required)
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/siteplatform/sitePlatformDataHandler/exportGongshangGradeInput",
        p,
        c
      )
  },
  sitePlatformDataHandler_handler: {
    /*
     * 处理
     * site 学校 (string query required)
     * type 类型 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/sitePlatformDataHandler/handler", p, c)
  },
  sitePlatformDataHandler_listGongshangClass: {
    /*
     * 工商班级列表
     */
    get: (p, c) =>
      $.get(
        "/api/ems/siteplatform/sitePlatformDataHandler/listGongshangClass",
        p,
        c
      )
  },
  sitePlatformDataHandler_listGongshangCourse: {
    /*
     * 课程列表
     * classId 班级id (integer query required)
     * grade 年级 (integer query )
     * learnNum 学期 (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/ems/siteplatform/sitePlatformDataHandler/listGongshangCourse",
        p,
        c
      )
  },
  sitePlatformDataHandler_resetGongshangPasswordBySignInInfo: {
    /*
     * 处理
     * account 账号 (string query required)
     * password 密码 (string query required)
     * schoolRollId 合同id (integer query required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/siteplatform/sitePlatformDataHandler/resetGongshangPasswordBySignInInfo",
        p,
        c
      )
  },
  sitePlatformDataHandler_uploadGongshangGrade: {
    /*
     * 成绩导入
     * classId 班级id (integer query required)
     * courseId 课程id (integer query required)
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/siteplatform/sitePlatformDataHandler/uploadGongshangGrade",
        p,
        c
      )
  },

  /**
   * 学校学习情况
   */
  siteStudy_batchSync: {
    /*
     * 批量同步
     * siteId 学校id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/siteplatform/siteStudy/batchSync", p, c)
  },
  siteStudy_check: {
    /*
     * 登记
     * account 账号 (string query )
     * id 行id (integer query required)
     * loginInfo 登录信息 (string query )
     * name 姓名 (string query required)
     * password 密码 (string query )
     * studentNo 学号 (string query )
     */
    post: (p, c) => $.post("/api/ems/siteplatform/siteStudy/check", p, c)
  },
  siteStudy_init: {
    /*
     * 初始化学校学习情况
     * siteId 省份 (integer query required)
     */
    post: (p, c) => $.post("/api/ems/siteplatform/siteStudy/init", p, c)
  },
  siteStudy_listHsy: {
    /*
     * 杭商院学校学习情况列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/siteStudy/listHsy", p, c)
  },
  siteStudy_listJiliang: {
    /*
     * 计量学校学习情况列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/siteStudy/listJiliang", p, c)
  },
  siteStudy_sync: {
    /*
     * 同步
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/siteplatform/siteStudy/sync", p, c)
  }
};
